import React from 'react';
import { useTranslation } from 'react-i18next';

function Values() {
  const { t } = useTranslation();

  const values = t('values.items', { returnObjects: true });

  return (
    <section className="values-section" id="values">
      <h3>{t('values.title')}</h3>
      <div className="values-grid">
        {values.map((value, index) => (
          <div key={index} className="value-card">
            <h4>{value.title}</h4>
            <p>{value.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Values;

